export const impactMock = {
  errors: [],
  data: {
    planImpact: [
      {
        offer: {
          id: 12279741968,
          name: 'Access / 80% MS',
          seller: {
            name: 'Wright Medical Technology Inc',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 3,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 2057513,
                spendVolumeBracket: null,
                unitVolume: 2276,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 2057516,
                spendVolumeBracket: null,
                unitVolume: 2276,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 173,
              excludedPlannedSpend: {
                spendVolume: 22850,
                spendVolumeBracket: null,
                unitVolume: 457,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 2034663,
                spendVolumeBracket: null,
                unitVolume: 1819,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 67163,
                spendVolumeBracket: null,
                unitVolume: 64,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 67163,
                spendVolumeBracket: null,
                unitVolume: 64,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 33,
              excludedPlannedSpend: {
                spendVolume: 1200,
                spendVolumeBracket: null,
                unitVolume: 24,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 65963,
                spendVolumeBracket: null,
                unitVolume: 40,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 1051,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 529295,
                spendVolumeBracket: null,
                unitVolume: 621,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 530346,
                spendVolumeBracket: null,
                unitVolume: 621,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 85,
              excludedPlannedSpend: {
                spendVolume: 5450,
                spendVolumeBracket: null,
                unitVolume: 109,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 523845,
                spendVolumeBracket: null,
                unitVolume: 512,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 12269039425,
          name: 'Access / Dual Source 90%',
          seller: {
            name: 'Zimmer Biomet',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 9608.5,
              savingsPct: 20,
              plannedSpend: {
                spendVolume: 37735.5,
                spendVolumeBracket: null,
                unitVolume: 106,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 47344,
                spendVolumeBracket: null,
                unitVolume: 106,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 38,
              excludedPlannedSpend: {
                spendVolume: 8126.5,
                spendVolumeBracket: null,
                unitVolume: 67,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 29609,
                spendVolumeBracket: null,
                unitVolume: 39,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 536,
              savingsPct: 8,
              plannedSpend: {
                spendVolume: 5470.5,
                spendVolumeBracket: null,
                unitVolume: 58,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 6006.5,
                spendVolumeBracket: null,
                unitVolume: 58,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 6,
              excludedPlannedSpend: {
                spendVolume: 3745.5,
                spendVolumeBracket: null,
                unitVolume: 56,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 1725,
                spendVolumeBracket: null,
                unitVolume: 2,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 2657.5,
              savingsPct: 7,
              plannedSpend: {
                spendVolume: 31923.1,
                spendVolumeBracket: null,
                unitVolume: 137,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 34580.6,
                spendVolumeBracket: null,
                unitVolume: 137,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 19,
              excludedPlannedSpend: {
                spendVolume: 18968.1,
                spendVolumeBracket: null,
                unitVolume: 132,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 12955,
                spendVolumeBracket: null,
                unitVolume: 5,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
      {
        offer: {
          id: 12279452871,
          name: 'Access / Dual 90',
          seller: {
            name: 'DePuy Synthes Co',
          },
        },
        planImpacts: [
          {
            facility: {
              name: 'Duke University Health System',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Raleigh Hospital',
              address: {
                city: 'Raleigh',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke MedUniversity Duke Medicine Pavillion',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Regional Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke University Hospital',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Orthopaedics Heritage',
              address: {
                city: 'Wake Forest',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
          {
            facility: {
              name: 'Duke Ambulatory',
              address: {
                city: 'Durham',
                state: 'NC',
              },
            },
            results: {
              spendLast12Month: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              savingsAmount: 0,
              savingsPct: 0,
              plannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              continuedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              conversionsCount: {
                totalConversionsCount: 0,
              },
              numberOfIncumbents: 0,
              excludedPlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
              compliancePlannedSpend: {
                spendVolume: 0,
                spendVolumeBracket: null,
                unitVolume: 0,
                productCount: 0,
              },
            },
          },
        ],
      },
    ],
  },
  extensions: null,
  dataPresent: true,
};
